import { usePaymentMethodsQuery } from '@api/GoodocAPI';
import { graphQLClient } from '@api/client';
import constate from 'constate';
import { useMemo } from 'react';

const usePaymentMethods = () => {
  const { data: paymentMethodsResponse, refetch: refetchPaymentMethods } =
    usePaymentMethodsQuery(graphQLClient);

  const checkValidate = useMemo(() => {
    return (
      paymentMethodsResponse?.paymentMethods?.filter(
        (paymentMethod) => paymentMethod.status !== 'register'
      ) || []
    );
  }, [paymentMethodsResponse]);

  return {
    paymentMethods: checkValidate,
    refetchPaymentMethods
  };
};

export const [PaymentMethodsProvider, usePaymentMethodsContext] =
  constate(usePaymentMethods);
